import React, { useCallback } from "react";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { GeoCard } from "@radarly/models/cards";
import { createClauseFromInnerClause } from "@radarly/models/clause/creator";
import { getDateFromClause } from "@radarly/models/clause/getter";
import { isHorizontalBarChartDataviz } from "@radarly/models/dataviz";
import { getTermFromAggs } from "@radarly/models/search";
import { useFragments } from "../fragment";
import { useGenerateCSV } from "../hooks/useGenerateCSV";
import { CardProps } from "../model";
import HorizontalBarChart from "./horizontal-bar-chart";
import Map from "./map";

const RadarlyGeoCards = ({
  card,
  openPostsPanel,
  timezone,
  forceReload,
  nowDate,
  ...props
}: CardProps<GeoCard>) => {
  const project = useCurrentProject();
  const fragments = useFragments(
    [card.fragments[0], card.fragments[1]],
    props.clause,
    props.from,
    props.to,
    timezone
  );
  const fragment = fragments[0];
  const term = getTermFromAggs(fragment.request.aggs);
  const dataviz = card.dataviz;
  const title = card.title;
  const { onGenerateCSV } = useGenerateCSV(title, fragments[0], fragments[1]);

  const onClickItem = useCallback(
    (id: string | number, range?: { from: Date; to: Date }) => {
      const { from, to } = getDateFromClause(fragment.request.query);
      openPostsPanel({
        clause: fragment.request.query,
        period: {
          from: range ? range.from : from,
          to: range ? range.to : to,
        },
        title,
        timezone,
        focusClause: createClauseFromInnerClause({ [term]: [id] }),
      });
    },
    [fragment.request.query, openPostsPanel, title, timezone, term]
  );
  return isHorizontalBarChartDataviz(dataviz) ? (
    <HorizontalBarChart
      fragments={fragments}
      project={project}
      dataviz={dataviz}
      title={title}
      height={props.height}
      onClickItem={openPostsPanel ? onClickItem : null}
      timezone={timezone}
      forceReload={forceReload}
      nowDate={nowDate}
      onGenerateCSV={onGenerateCSV}
    />
  ) : (
    <Map
      fragment={fragment}
      project={project}
      dataviz={dataviz}
      title={title}
      height={props.height}
      onClickItem={openPostsPanel ? onClickItem : null}
      timezone={timezone}
      forceReload={forceReload}
      nowDate={nowDate}
      onGenerateCSV={onGenerateCSV}
    />
  );
};

export default RadarlyGeoCards;
